import React from "react";
import { SectionHeading } from "../../atom/SectionHeading";
import { CornerUser } from "../../atom/CornerUser";
import { DraggableScrollContainer } from "../../atom/DraggableScrollContainer";
import { useTranslation } from "react-i18next";
import { LegalDocumentsTable } from "./LegalDocumentsTable";

export const LegalDocuments = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col flex-1 items-center w-full flex-grow">
      <div className="w-full overflow-hidden flex flex-col flex-grow">
        <DraggableScrollContainer className="m-[20px] overflow-y-auto select-none ml-[8px] bg-gray-100 flex-grow">
          <div className="flex flex-col gap-10">
            <div className="px-12 pt-10">
              <SectionHeading
                title={t("Legal Documents")}
                subtitle={t(
                  "Manage your legal documents — Seamlessly access, organize, and keep track of all your important legal files in one secure place.",
                )}
                subtitleClassName="max-w-[560px]"
                cornerComponent={<CornerUser />}
              />
            </div>

            <div className="flex flex-col bg-white ml-12 mr-[52px] mb-[75px] rounded-[6px] shadow">
              <LegalDocumentsTable />
            </div>
          </div>
        </DraggableScrollContainer>
      </div>
    </div>
  );
};
